import React from "react";
import MasterDetailLayout from "../../../../components/layout/MasterDetailLayout";
import ReconciliationCompactList from "../components/ReconciliationCompactList";

const ReconciliationSplitView = () => <MasterDetailLayout list={<ReconciliationCompactList />} />;

export default ReconciliationSplitView;
